/**
 * Centralized site configuration, add whatever you need here.
 */
export default {
  siteTitle: "CreatorGrid",
  siteDescription: "Where creators and brands connect",
  siteUrl: "https://creatorgrid.io",
  siteImage: "/images/og-image.png",
  favicon: "/src/assets/logo.png",
  twitterHandle: "",
  email: "youssef@creatorgrid.io",
  address: "",
};
